<template>
  <div>
    <v-row>
      <v-col class="col-12 pt-0">
        <v-text-field
            filled
            v-model="title"
            :error-messages="errors.title"
            label="Título"
            autocomplete="title"
            name="title"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-format-text"
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12" v-if="id">
        <v-text-field
            filled
            :value="'https://app.controllersolar.com.br/dashboard/' + id + '/' + uid"
            label="Link público de relatório"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-link-box"
            type="text"
            readonly
            @focus="$event.target.select()"
        ></v-text-field>
      </v-col>
      <!--
      <v-col class="col-12 col-md-6" v-if="id">
        <v-text-field
            filled
            :value="'https://app.controllersolar.com.br/credential/' + id + '/' + uid"
            label="Link de crendiamento"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-link"
            type="text"
            readonly
        ></v-text-field>
      </v-col>
      -->
      <v-col class="col-12 col-md-6">
        <v-text-field
            filled
            v-model="power_tax"
            :error-messages="errors.power_tax"
            label="Taxa de consumo atual de energia em valor (R$)"
            autocomplete="power_tax"
            name="power_tax"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-currency-usd"
            type="text"
            v-money
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-md-6">
        <v-select
          filled
          dense
            :items="days_start"
            v-model="day_start"
            label="Dia de leitura da fatura"
            hide-details="auto"
            class="mt-0"
        ></v-select>
      </v-col>
      <v-col class="col-12 col-md-6">
        <v-text-field
            filled
            v-model="power_total"
            :error-messages="errors.power_total"
            label="Consumo total/mês atual de energia em KWP"
            autocomplete="power_total"
            name="power_total"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-flash"
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-md-6">
        <v-text-field
            filled
            v-model="panels"
            :error-messages="errors.panels"
            label="Quantidade de painéis"
            autocomplete="panels"
            name="panels"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-solar-panel-large"
            type="text"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      
      <v-col class="col-12">
        <v-select
          filled
            :items="plans"
            v-model="plan_id"
            item-value="id"
            item-text="title"
            label="Plano"
            hide-details="auto"
            class="mt-0"
            style="padding-top: 6px"
        ></v-select>
      </v-col>
      <v-col class="col-12 col-sm-4">
        <v-text-field
          filled
          v-model="bill_start_month"
          :error-messages="errors.power_total"
          label="Mês início da cobrança (1-12)"
          name="bill_month"
          hide-details="auto"
          placeholder="MM"
          prepend-inner-icon="mdi-calendar"
          type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-4">
        <v-text-field
          filled
          v-model="bill_start_year"
          :error-messages="errors.power_total"
          label="Ano início da cobrança"
          name="bill_year"
          hide-details="auto"
          placeholder="AAAA"
          prepend-inner-icon="mdi-calendar"
          type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-4">
        <v-text-field
          filled
          v-model="bill_due_day"
          :error-messages="errors.power_total"
          label="Data de vencimento"
          name="bill_day"
          hide-details
          persistent-hint
          placeholder="DD"
          prepend-inner-icon="mdi-calendar"
          xhint="Deve ser maior ou igual dia leitura"
          type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12">
        
        
        <v-menu
          ref="menu1"
          v-model="clear_datepicker"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              filled
              v-model="clear_date_formated"
              label="Data da próxima limpeza"
              hint="DD/MM/AAAA"
              placeholder="DD/MM/AAAA"
              hide-details
              prepend-inner-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
              @blur="date = parseDate(clear_date)"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="clear_date"
            no-title
            @input="clear_datepicker = false"
          ></v-date-picker>
        </v-menu>
        
        
      
      </v-col>
    </v-row>
    <div class="mt-5 bgalpha pa-2 text-right">
      <v-btn
          v-if="id"
          color="error"
          @click="prepareDeleteDialog()"
          :loading="editState"
          class="mr-2"
      >
        Excluir
      </v-btn>
      <v-btn
          color="success"
          @click="projectEdit()"
          :loading="editState"
      >
        Salvar
      </v-btn>
    </div>
    <v-dialog
            v-model="deleteDialog"
            width="500"
        >
          <v-card>
            <v-toolbar flat>
              <div class="title" style="color:#444;">Excluir Projeto</div>
              <v-spacer></v-spacer>
              <v-btn
                  icon
                  @click="deleteDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>

            <v-card-text class="pb-0">
              <v-row>
                <v-col class="col-12">
                  Deseja realmente excluir este projeto?
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="error"
                @click="deleteDialog = false"
              >
                Não
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="projectDelete()"
              >
                Sim
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  </div>
</template>

<script>
import { dateFormat } from '../components/mixins/dateFormat';

export default {
  mixins: [
    dateFormat
  ],
  props: {
    project_id: String
  },
  mounted() {
    this.projectInfo();
    this.planLoad();
  },
  data() {
    return {
      errors: [],
      editState: false,
      deleteDialog: false,

      days_start: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28],

      plans: [],

      id: 0,
      uid: '',
      title: '',
      power_tax: '',
      power_total: 0,
      panels: 0,
      day_start: 0,
      plan_id: 0,
      clear_datepicker: false,
      clear_date: '',
      clear_date_formated: '',

      bill_start_year: 0,
      bill_start_month: 0,
      bill_due_day: 0,

      plan_start_calendar: false
    }
  },
  computed: {
    plan_start_formated() {
      //return this.formatDate(this.plan_start_at);
    },
  },
  methods: {
    projectInfo() {
      const payload = {
        id: this.$route.params.project_id
      };

      if (payload.id > 0) {
        this.$api
          .post('/admin/project.info', payload)
          .then(response => {

            this.id = response.data.id,
            this.uid = response.data.uid,
            this.title = response.data.title,
            this.power_tax = response.data.power_tax,
            this.power_total = response.data.power_total,
            this.panels = response.data.panels,
            this.day_start = response.data.day_start,
            this.plan_id = response.data.plan_id,
            this.clear_date = response.data.clear_date
            if (this.clear_date != '') {
              this.clear_date_formated = this.parseDate(this.clear_date);
            }

            this.bill_start_year = response.data.bill_start_year,
            this.bill_start_month = response.data.bill_start_month,
            this.bill_due_day = response.data.bill_due_day

          });
      }
    },
    planLoad() {
      this.$api
          .get('/admin/plan/plan.list')
          .then(response => {
            this.plans = response.data
          });
    },
    prepareDeleteDialog() {
      this.deleteDialog = true;
    },
    projectEdit() {
      this.editState = true;

      const payload = {
        id: this.id,
        title: this.title,
        power_tax: this.power_tax.toString().replace(/[^0-9]/g,''),
        power_total: this.power_total,
        panels: this.panels,
        day_start: this.day_start,
        //plan_start_at: this.plan_start_at,
        plan_id: this.plan_id,
        bill_start_year: this.bill_start_year,
        bill_start_month: this.bill_start_month,
        bill_due_day: this.bill_due_day,
        clear_date: this.clear_date
      }

      this.$api
          .post('/admin/project.edit', payload)
          .then(response => {

            if (!payload.id) {
              this.$router.push({
                name: 'adminProjectEdit',
                params: {
                  project_id: response.id
                }
              })

              return;
            }

            this.errors = [];
            
            if (response.data.id > 0) {
              this.id = response.data.id;
            }

            this.$root.$emit('GlobalSnackbar', {type: 'success', message: 'Projeto salvo'});
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          })
          .finally(() => {
            this.editState = false;
          });
    },
    projectDelete() {
      this.editState = true;

      const payload = {
        project_id: this.id
      }

      this.$api
          .post('/admin/project.remove', payload)
          .then(response => {
            this.$router.push({
              name: 'adminProjectList'
            });

            this.$root.$emit('GlobalSnackbar', {type: 'success', message: 'Projeto excluído'});
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          })
          .finally(() => {
            this.editState = false;
          });
    },
    parseDate(date) {
      if (!date) return ''

      const [year,month,day] = date.split('-');
      
      this.clear_date_formated = `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
    },
  },
}
</script>

<style>
</style>
